export const CHART_TYPES = {
  LINE: 'line',
  BAR: 'bar',
  TREEMAP: 'treemap',
  DOUGHNUT: 'doughnut',
  SANKEY: 'sankey',
  FUNNEL: 'funnel',
  HORIZONTAL_BAR: 'HORIZONTAL_BAR',
  SPARKLINE: 'sparkline'
};

export const X_AXIS_TYPE = {
  SINGLE_TIME_FIELD_SINGLE_NON_TIME_FIELD: 'SINGLE_TIME_FIELD_SINGLE_NON_TIME_FIELD',
  SINGLE_TIME_FIELD: 'SINGLE_TIME_FIELD',
  SINGLE_NON_TIME_FIELD: 'SINGLE_NON_TIME_FIELD',
  SIMPLE_KPI: 'SIMPLE_KPI'
};
